// Обмен Telegram.WebApp.initData на Bearer JWT (docs/04-api-contract.md §2).
import type { ApiResponse } from "@shopkit/shared";

import { apiRequest } from "./client";

export type ShopAuthResponse = ApiResponse<"authenticateShop">;

/**
 * authenticateShop входит в витрину по slug магазина и Telegram initData.
 * Бросает ApiError: 401 — подпись initData не прошла, 404 — магазин не найден,
 * 409 shop_unavailable — магазин не в статусе active.
 */
export function authenticateShop(shop: string, initData: string, signal?: AbortSignal): Promise<ShopAuthResponse> {
  return apiRequest<ShopAuthResponse>("/api/v1/auth", {
    method: "POST",
    skipAuth: true,
    signal,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ shop, init_data: initData }),
  });
}
